import { Card, Button } from '@heroui/react'
import { Zap } from 'lucide-react'

export interface TopupCardProps {
  title: string
  description: string
  price: string
  oneTimePurchaseText?: string
  buttonText?: string
  processingText?: string
  onSubscribe: () => void
  isLoading?: boolean
}

export function TopupCard({
  title,
  description,
  price,
  oneTimePurchaseText = 'One-time purchase',
  buttonText = 'Buy Now',
  processingText = 'Processing...',
  onSubscribe,
  isLoading,
}: TopupCardProps) {
  return (
    <Card className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-background to-secondary/20 border-secondary">
      <div className="flex items-center gap-4 mb-4 sm:mb-0">
        <div className="p-3 bg-primary/10 rounded-full text-primary">
          <Zap className="w-8 h-8" />
        </div>
        <div>
          <h3 className="text-xl font-bold">{title}</h3>
          <p className="text-muted-foreground text-sm">
            {description}
          </p>
        </div>
      </div>
      
      <div className="flex items-center gap-4 w-full sm:w-auto">
        <div className="text-right flex-1 sm:flex-none">
          <div className="text-2xl font-bold">{price}</div>
          <div className="text-xs text-muted-foreground">{oneTimePurchaseText}</div>
        </div>
        <Button
          variant="secondary"
          onPress={onSubscribe}
          isDisabled={isLoading}
        >
          {isLoading ? processingText : buttonText}
        </Button>
      </div>
    </Card>
  )
}
